import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_STATISTICS_SUCCESS,
  FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS
} from "./membershipSalesSagas";

export const initialState = {
  initRequest: false,
  prevPageFilters: { prevDate: null },
  statistics: {
    activeMembers: {},
    cancelledMembers: {},
    churnRate: {},
    newMembers: {},
    frozenMembers: {},
    attritionRate: {},
    units: {},
    unitsYearOverYearComparison: [],
    unitsDayOverDayComparison: []
  },
  chartData: {},
  initialized: false,
  isLoading: true,
  currentDate: null
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_STATISTICS_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      statistics: action.payload || state.statistics
    }),
    [FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload || state.chartData
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      currentDate: action.payload
    })
  },
  initialState
);
